import { jsx, jsxs } from "react/jsx-runtime";
import { bool, func, string } from "prop-types";
import {
  DSDialog,
  DSDialogBody,
  DSDialogFooter,
  DSDialogSeparator,
  DSDialogDefaultLayout,
  DSDialogPrimaryMessage,
  DSDialogSecondaryMessage
} from "@elliemae/ds-dialog";
import { DSButtonV2 } from "@elliemae/ds-button";
import { InfoCircle } from "@elliemae/ds-icons";
const MultipleProductsInfo = ({
  isModalOpen,
  handleCancel,
  selectedPrograms
}) => /* @__PURE__ */ jsxs(DSDialog, { isOpen: isModalOpen, size: "small", onClickOutside: handleCancel, children: [
  /* @__PURE__ */ jsx(DSDialogBody, { children: /* @__PURE__ */ jsxs(DSDialogDefaultLayout, { children: [
    /* @__PURE__ */ jsx(InfoCircle, { size: "xxl" }),
    /* @__PURE__ */ jsx(DSDialogPrimaryMessage, { children: "Multiple Products Selected" }),
    /* @__PURE__ */ jsxs(DSDialogSecondaryMessage, { children: [
      "Your program selections could have conflicting fee factors. Prior to selection, validate your factor applies to the selected program. Selected products are: ",
      selectedPrograms,
      "."
    ] })
  ] }) }),
  /* @__PURE__ */ jsx(DSDialogSeparator, {}),
  /* @__PURE__ */ jsx(DSDialogFooter, { children: /* @__PURE__ */ jsx(DSButtonV2, { onClick: handleCancel, children: "Okay" }) })
] });
MultipleProductsInfo.defaultProps = {
  isModalOpen: false
};
MultipleProductsInfo.propTypes = {
  isModalOpen: bool,
  selectedPrograms: string.isRequired,
  handleCancel: func.isRequired
};
export {
  MultipleProductsInfo
};
